import React, { useEffect, Fragment, useState, useRef } from 'react'
import { Modal } from 'react-bootstrap'
import Procesos from './components/procesos';


const ConsultaProcesosJudiciales = ({ showModal, setShowModal, idCaso, idOrgCaso, tipoGestion }) => {
    return (
        <Fragment>
            <Modal show={showModal} onHide={() => setShowModal(false)} size='xl'>
                <Procesos 
                    idCaso={idCaso}
                    idOrgCaso={idOrgCaso}
                    tipoGestion={tipoGestion}
                    showModal={showModal}
                    setShowModal={setShowModal}
                />
            </Modal>

            <style type='text/css'>
                {`
                    .customHeader {
                        background-color: rgb(176 175 196);
                        color: #3a3a8d;
                        font-size: 17px;
                        font-weight: 600
                    }
                    .customHeader span{
                        background-color: rgb(176 175 196);
                        color: #6363d7;
                        font-size: 15px;
                        font-weight: 600
                    }
                    .customCard {
                        padding-top: 0;
                        padding-left: 0;
                        padding-right: 0;
                    }
                    .customTable > thead {
                        color: white; 
                        background-color: rgb(114, 139, 176);
                    }
                    .customTable > thead > tr > th {
                        padding: 20px 0;
                    }
                    .table>:not(:first-child) {
                        border-top: none;
                    }
                    .customSearch {
                        color: #fff;
                        background-color: #ffc107;
                        border-color: #ffc107;
                    }
                `}
            </style>
        </Fragment>
    )
}

export default ConsultaProcesosJudiciales